import { Images } from "constants";
import React, { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const list = [
  {
    _id: 1,
    label: "Users",
    link: "/user",
    icon: "sif_userIcon",
  },
  {
    _id: 16,
    label: "Deleted Users",
    link: "/deleted_user",
    icon: "sif_userIcon",
  },
  {
    _id: 2,
    label: "Sifarishes",
    link: "/sifarish",
    icon: "sif_sifaIcon",
  },
  {
    _id: 3,
    label: "Deleted Sifarishes",
    link: "/deleted_sifarish",
    icon: "sif_delSifIcon",
  },
  {
    _id: 4,
    label: "Reported Sifarishes",
    link: "/reported_sifarish",
    icon: "sif_repSifIcon",
  },
  {
    _id: 12,
    label: "Contact",
    link: "/contact",
    icon: "sif_conIcon",
  },
  {
    _id: 7,
    label: "Broadcast",
    link: "/brodcasting",
    icon: "sif_broIcon",
  },
  {
    _id: 7,
    label: "Broadcast History ",
    link: "/brodcasting_history",
    icon: "sif_broHisIcon",
  },
  {
    _id: 14,
    label: "Leaderboard",
    link: "/leaderboard",
    icon: "sif_leaIcon",
  },
  {
    _id: 13,
    label: "Sifarish Points",
    link: "/sifarish_points",
    icon: "sif_poiIcon",
  },
  {
    _id: 5,
    label: "Sessions",
    link: "/session",
    icon: "sif_sesIcon",
  },
  {
    _id: 6,
    label: "Categories",
    link: "/categories",
    icon: "sif_catIcon",
  },

  {
    _id: 8,
    label: "App Version",
    link: "/manage_app_version",
    icon: "sif_appIcon",
  },
  {
    _id: 9,
    label: "Android App",
    link: "https://play.google.com/store/apps/details?id=com.mysifarish&hl=en",
    icon: "sif_andIcon",
    openInNewTab: true,
  },
  {
    _id: 10,
    label: "iOS App",
    link: "https://apps.apple.com/us/app/mysifarish/id6742560730",
    icon: "sif_iosIcon",
    openInNewTab: true,
  },
  {
    _id: 11,
    label: "Website",
    link: "https://www.mysifarish.com/",
    icon: "sif_webIcon",
    openInNewTab: true,
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menulist, setMenuList] = useState(list);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    //  SideBar Start
    <aside className="sideBar">
      <div className="_logoInx">
        <img className="logo_long" src={Images.LOGO2.default} alt="" />
        <img className="logo_short" src={Images.LOGO_SHORT.default} alt="" />
      </div>

      <div className="menuBx_otr">
        <ul className="_simpList accordion" id="accordionExample">
          {/* {menulist &&
            menulist?.map((item, outerIndex) => {
              return (
                <li className="_clk_li" key={`sidemenubar_${outerIndex}`}>
                  <NavLink
                    to={item?.link || "#"}
                    className={({ isActive }) =>
                      `_clk_a ${isActive ? "active" : ""}`
                    }
                    // onClick={(event) =>
                    //   handleNavLinkClick(item?.link, event, outerIndex)
                    // }
                  >
                    <i className={item?.icon}></i>
                    <span>{item?.label}</span>
                  </NavLink>
                </li>
              );
            })} */}

          {menulist?.map((item, outerIndex) => (
            <li className="_clk_li" key={`sidemenubar_${outerIndex}`}>
              {item.openInNewTab ? (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="_clk_a"
                >
                  <i className={item?.icon}></i>
                  <span>{item?.label}</span>
                </a>
              ) : (
                <NavLink
                  to={item?.link || "#"}
                  className={({ isActive }) =>
                    `_clk_a ${isActive ? "active" : ""}`
                  }
                >
                  <i className={item?.icon}></i>
                  <span>{item?.label}</span>
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
